import React, { Component } from "react";
import styled from "styled-components";
import { Drawer, List } from "rsuite";
import AddSimComponent from "./addSimComponent";
import OtherOptionComponent from "./otherOptionComponent";
import ManageDeviceComponent from "./manageDeviceComponent";
import ChargSimComponent from "./chargSimComponent";

const Logo = styled.img`
  width: 25px;
  transition: 100ms;
  &:active {
    transform: scale(0.85);
  }
`;
const DrawerBox = styled.div`
  ${(props) => props.display !== "main" && "padding: 15px"};
`;

const Item = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
`;
const SettingIcon = styled.img`
  height: 30px;
  object-fit: contain;
`;
const ItemA = styled.a`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none !important;
  color: unset !important;
  padding: 0 15px;
`;

class SettingComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      display: "main",
    };
  }

  render() {
    const { show, display } = this.state;
    const sound = new Audio("/assets/click.mp3");
    return (
      <>
        <Logo
          src="/assets/new_setting.png"
          alt="setting"
          onClick={() => {
            sound.play();
            this.setState({ show: true });
          }}
        />
        <Drawer
          open={show}
          onClose={() => this.setState({ show: false, display: "main" })}
          size="xs"
          style={{ maxWidth: "300px", borderRight: "1px solid darkorange" }}
          placement="right"
        >
          <Drawer.Header>
            <Drawer.Title>تنظیمات</Drawer.Title>
          </Drawer.Header>
          <DrawerBox display={display}>
            {display === "main" ? (
              <>
                <List>
                  <List.Item
                    onClick={() => {
                      sound.play();
                      this.setState({ display: "manageDevice" });
                    }}
                  >
                    <Item>
                      <p>مدیریت دستگاه ها</p>
                      <SettingIcon
                        src="/assets/setting/manage_device.png"
                        alt="🧐"
                      />
                    </Item>
                  </List.Item>
                  <List.Item
                    onClick={() => {
                      sound.play();
                      this.setState({ display: "chargSim" });
                    }}
                  >
                    <Item>
                      <p>شارژکردن سیمکارت</p>
                      <SettingIcon
                        src="/assets/setting/charg_sim.png"
                        alt="🧐"
                      />
                    </Item>
                  </List.Item>
                  <List.Item
                    onClick={() => {
                      sound.play();
                      this.setState({ display: "addNumber" });
                    }}
                  >
                    <Item>
                      <p>ثبت شماره در دستگاه</p>
                      <SettingIcon
                        src="/assets/setting/register_phone.png"
                        alt="🧐"
                      />
                    </Item>
                  </List.Item>
                  <List.Item
                    onClick={() => {
                      sound.play();
                      this.setState({ display: "otherOption" });
                    }}
                  >
                    <Item>
                      <p>سایر آپشن‌ها </p>
                      <SettingIcon
                        src="/assets/setting/setting_big.png"
                        alt="🧐"
                      />
                    </Item>
                  </List.Item>
                  <List.Item onClick={() => sound.play()}>
                    <ItemA href="https://xitonix.com/agencies">
                      <p>نمایندگی ها</p>
                      <SettingIcon
                        src="/assets/setting/ic_agency.png"
                        alt="🧐"
                      />
                    </ItemA>
                  </List.Item>
                  <List.Item onClick={() => sound.play()}>
                    <ItemA href="https://xitonix.com/faq">
                      <p>سوالات متداول</p>
                      <SettingIcon src="/assets/setting/ic_help.png" alt="🧐" />
                    </ItemA>
                  </List.Item>
                  <List.Item onClick={() => sound.play()}>
                    <ItemA href="https://xitonix.com/education">
                      <p>آموزش</p>
                      <SettingIcon
                        src="/assets/setting/ic_education.png"
                        alt="🧐"
                      />
                    </ItemA>
                  </List.Item>
                  <List.Item onClick={() => sound.play()}>
                    <ItemA href="https://xitonix.com/about">
                      <p>درباره ما</p>
                      <SettingIcon src="/assets/setting/call_us.png" alt="🧐" />
                    </ItemA>
                  </List.Item>
                </List>
              </>
            ) : display === "manageDevice" ? (
              <ManageDeviceComponent
                handleBack={() => this.setState({ display: "main" })}
              />
            ) : display === "chargSim" ? (
              <ChargSimComponent
                handleBack={() => this.setState({ display: "main" })}
              />
            ) : display === "addNumber" ? (
              <AddSimComponent
                handleBack={() => this.setState({ display: "main" })}
              />
            ) : display === "otherOption" ? (
              <OtherOptionComponent
                handleBack={() => this.setState({ display: "main" })}
              />
            ) : null}
          </DrawerBox>
        </Drawer>
      </>
    );
  }
}

export default SettingComponent;
